import React from "react";

import "./Toaster.css";

export const Toaster = ({title, message, color, borderColor}) => {

    return (
      <div className="toaster-container" style={{backgroundColor: color, border: `3px solid ${borderColor}`}}>
            <p className="toaster-title">{title}</p>
            <p className="toaster-message">{message}</p>
      </div>
    );
}
